import { HiikerMapStyle } from '../../utils/models/MapStyles';
import { withoutSlots } from '../../utils/models/styleJsonUrl';

/**
 * The map style URL a flyover should render with: the user's currently-selected map style (pro-aware),
 * matching the recording map / flyover preview. Used by the post-save "Generate 3D flyover" path so it
 * sends a concrete style instead of letting the backend fall back to its default.
 *
 * Kept out of the recordings entrypoint (which runs DOM/side-effect code on import) so the style
 * selection is unit-testable in isolation.
 *
 * Without the on-screen `slots=1` param: a video is keyed on its style URL (FlyoverVideo's
 * uniqueness scope), so sending the slotted URL would re-render every existing video.
 */
export function flyoverShareStyleUrl(isPro: boolean): string {
  return withoutSlots(HiikerMapStyle.getCurrentStyle(isPro).styleUrl);
}
